module.exports = __webpack_public_path__ + "img/more.38556c1a.svg";